import PurchaseOrderStatusBadge from '#/modules/srmMgmt/purchaseOrder/components/PurchaseOrderStatusBadge';
import { formatDateOrDash } from '#/utils/date';

function dash(value) {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  return value;
}

function formatListDate(value) {
  if (value == null || value === '') {
    return '-';
  }
  return formatDateOrDash(String(value).trim().slice(0, 10));
}

function formatSupplierLabel(row) {
  const supplier = row?.supplier;
  if (!supplier) {
    return '-';
  }
  const label = [supplier.code, supplier.name].filter(Boolean).join(' - ');
  return label || '-';
}

/** Block A：僅狀態 */
export const purchaseOrderSideMsgStatusBlock = {
  fields: [
    {
      key: 'status',
      label: '狀態',
      render: (row) => (
        <div className="side_msg-row">
          <h3>狀態</h3>
          {row?.status
            ? <PurchaseOrderStatusBadge status={row.status} size="sm" />
            : <p>-</p>}
        </div>
      ),
    },
  ],
};

/** Block C：其餘欄位（唯讀；無簽核） */
export const purchaseOrderSideMsgDetailBlock = {
  fields: [
    { label: '採購單號', value: 'purchaseOrderNo' },
    { label: '供應商', value: formatSupplierLabel },
    {
      label: '建立日期',
      value: (row) => formatListDate(row?.record?.createdAt),
    },
    {
      label: '結案日期',
      value: (row) => formatListDate(row?.history?.closedAt),
    },
    { label: '備註', value: (row) => dash(row?.remark) },
  ],
};

export const purchaseOrderSideMsgBlocks = [
  purchaseOrderSideMsgStatusBlock,
  purchaseOrderSideMsgDetailBlock,
];
